import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 30/40;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 40 30" version="1.1">
        <g id="The-Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="v-1.5" transform="translate(-389.000000, -2603.000000)" fill={color}>
                <g id="UI" transform="translate(97.000000, 2497.000000)">
                    <g id="Check-1" transform="translate(288.000000, 96.000000)">
                        <path d="M16.5443551,38.0270735 L5.11578369,26.598502 C3.6280721,25.1107904 3.6280721,22.6987334 5.11578369,21.2110218 C6.60349528,19.7233102 9.01555234,19.7233102 10.5032639,21.2110218 L19.2380952,29.999503 L37.4967361,11.6872123 C38.9844477,10.1995007 41.3965047,10.1995007 42.8842163,11.6872123 C44.3719279,13.1749238 44.3719279,15.5869809 42.8842163,17.0746925 L21.9318354,38.0270735 C20.4441238,39.514785 18.0320667,39.514785 16.5443551,38.0270735 Z" id="Combined-Shape"></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export default class IconCheck extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
